import {MimickIntersection} from './MimickIntersection';

export class MimickPointer {
    readonly intersection:MimickIntersection;
    constructor() {
        this.intersection = new MimickIntersection();
    }
}
